import React, { Component } from "react";
import { Icon, Modal, Grid } from "semantic-ui-react";
import moment from "moment";

class ViewNotes extends Component {
    static defaultProps = {
        prevNotes: [],
    };

    state = {
        view: false,
        prevNotes: [],
        load: false,
    };

    getComments = async () => {
        this.setState({ prevNotes: this.props.prevNotes, view: true });
    };

    toggleModal = (view) => {
        this.setState({ view });
    };

    render() {
        const { view, prevNotes } = this.state;
        let uniquePrevNotes = [];

        prevNotes.forEach((prevNote) => {
            const alreadyExists = uniquePrevNotes.some(
                (a) => a.note === prevNote.note && a.user === prevNote.user
            );
            if (!alreadyExists) {
                uniquePrevNotes.push(prevNote);
            }
        });

        return (
            <>
                {this.props.prevNotes && this.props.prevNotes.length > 0 && (
                    <Icon
                        onClick={() => this.getComments()}
                        style={{ cursor: "pointer", fontWeight: 800 }}
                        name="history"
                    />
                )}

                <Modal
                    size="small"
                    onClose={() => this.toggleModal(false)}
                    onOpen={() => this.toggleModal(true)}
                    open={view}
                >
                    <Modal.Header>Notes</Modal.Header>
                    <Modal.Content>
                        <Grid>
                            {(uniquePrevNotes || []).map((note, i) => (
                                <Grid.Row key={i} className="p05 mb20 borderBottomGray">
                                    <Grid.Column className="text-center" width={2}>
                                        <Icon name="user" size="large" />
                                        <br />
                                        {note.user}
                                    </Grid.Column>
                                    <Grid.Column width={14}>
                                        <p className="mb0">
                                            <small>{moment(note.date).format("HH:mm, D MMM YYYY")}</small>
                                        </p>
                                        <p>{note.note}</p>
                                    </Grid.Column>
                                </Grid.Row>
                            ))}
                        </Grid>
                    </Modal.Content>
                </Modal>
            </>
        );
    }
}

export default ViewNotes;
